import { Checkbox, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { centsToDollarsDisplay } from '../../displayFormatters'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: (deleteFromQuickBooks: boolean) => void
  selectedCount: number
  selectedTotalCents: number
  showDeleteFromQuickBooksOption: boolean
  isLoading: boolean
}

const BulkDeleteConfirmationModal = ({
  open, onClose, onConfirm,
  selectedCount, selectedTotalCents, showDeleteFromQuickBooksOption,
  isLoading,
}: Props) => {
  const [deleteFromQuickBooks, setDeleteFromQuickBooks] = useState(true)

  useEffect(() => {
    if (!open) {
      setDeleteFromQuickBooks(true)
    }
  }, [open])

  return (
    <Modal
      open={open}
      title={`Delete ${selectedCount} invoice${selectedCount === 1 ? '' : 's'}?`}
      okText="Delete"
      okButtonProps={{ danger: true, loading: isLoading }}
      onOk={() => onConfirm(deleteFromQuickBooks)}
      onCancel={onClose}
    >
      <p>
        You're about to delete {selectedCount} invoice{selectedCount === 1 ? '' : 's'} totaling {centsToDollarsDisplay(selectedTotalCents)}.
        Paid invoices will be skipped and surface as errors in the batch history.
      </p>
      {showDeleteFromQuickBooksOption && (
        <Checkbox checked={deleteFromQuickBooks} onChange={(e) => setDeleteFromQuickBooks(e.target.checked)}>
          Also delete from QuickBooks
        </Checkbox>
      )}
    </Modal>
  )
}

export default BulkDeleteConfirmationModal
